import { handleCardTextChange } from './cart-page';
import { selectAllNodes, selectNode } from './helpers';
import {checkShopOpenDate} from './shared'
import {getZipcodes} from './cart'

// update WC session
function updateSession(data) {
  return jQuery.ajax({
    url: window.sharedResources.ajaxurl,
    type: 'POST',
    data: {
      action: 'update-session',
      payload: data
    }
  });
}


// init jQuery-UI date picker and bind some actions
async function initDatepicker($) {
    const zonesObj = await getZipcodes()
    const zipcodes = Object.keys(zonesObj.zones).reduce((res, el) => {
        const value = zonesObj.zones[el]
        return [
            ...res,
            ...value.zone_locations.map(zone => ({...zone, name: value.zone_name}))
        ]
    }, [])

    const CITY_ZONE_NAME = window.sharedResources.sameDayZoneName || '';
    const isValidZipcode = zipcodeValue =>
        zipcodes.some(
            ({code, name}) => code == zipcodeValue && name === CITY_ZONE_NAME
        )

  const $datepickerField = $('#delivery-modal-date');

    // set regional standard
    $.datepicker.setDefaults($.datepicker.regional['sv'])

    $datepickerField.datepicker({
        beforeShowDay(date) {
            return [checkShopOpenDate(date, isValidZipcode(document.querySelector('#shipping_postcode').value)), '']
        },
        minDate: 0,
        onClose(date) {
            updateSession({ date })
        },
    })
  $('.delivery-modal__label.date-input-field').on('click', function() {
    $datepickerField.datepicker('show');
  });
}

// character counter for textarea
function characterCounter(container) {
  const counterNode = selectNode('card-text-counter', container);
  const textarea = selectNode('additional-input', container);
  const { value, maxLength } = textarea;
  if (textarea.classList.contains('full')) return;

  const updateCounterNode = e => {
    const count = !e ? value.length : e.target.value.length;
    counterNode.innerHTML = `${maxLength}/${count}`;
  };

  updateCounterNode();

  textarea.addEventListener('input', updateCounterNode);
}

// check for the right WC ajax action and then re-init scripts because DOM elements were rewritten
function updateScriptsAfterWcChange($) {
    $(document).on('updated_checkout', function () {
        const cardTextInputs = selectAllNodes('additional-input')
        const cardTextContainers = selectAllNodes('greeting-text-table-cell')

        initDatepicker($)

        // handle card text change
        if (cardTextInputs.length) handleCardTextChange(cardTextInputs)
        if (cardTextContainers.length) cardTextContainers.map(characterCounter)
    })
}

export function cardText() {
    const cardTextContainers = selectAllNodes('greeting-text-table-cell');
    if (cardTextContainers.length) cardTextContainers.map(characterCounter);
}
export default function checkoutScripts($) {
  const $postcodeInput = $('#shipping_postcode');
    cardText()
  let prevZipcode = $postcodeInput.val();

  $postcodeInput.attr('disabled', 'disabled');

  // remove WC event handlers from billing form. It needs to be done with async approach
  window.setTimeout(() => {
    $('form.checkout').off(
      'input keydown change',
      '.address-field input.input-text, .update_totals_on_change input.input-text'
    );
    $postcodeInput.removeClass('disabled');
  }, 0);


  // Change scroll position Woocommerce  errors
    jQuery( function( $ ) {
        $.scroll_to_notices = function( scrollElement ) {
            if ( scrollElement.length ) {
                $( 'html, body' ).animate( { scrollTop: ( scrollElement.offset().top - 200 ) }, 1000 );
            }
        };
    });

  // trigger shipping methods recalculation and session update
  async function handleZipcodeUpdate({ target }) {
    const zipcode = target.value;

    if (zipcode === prevZipcode) return;

    target.classList.add('disabled');
    const result = await updateSession({ zipcode });
    prevZipcode = result.zipcode;
    $('body').trigger('update_checkout');
    target.classList.remove('disabled');
  }

  $postcodeInput.on('blur', handleZipcodeUpdate);

  if ($('#delivery-modal-date').length) {
    // wait for the datepicker script load
    const intervalId = window.setInterval(() => {
      if ($.datepicker.version) {
        stopInterval();
        updateScriptsAfterWcChange($);
      }
    }, 100);

    function stopInterval() {
      window.clearInterval(intervalId);
    }
  }
}
